module.exports = __webpack_public_path__ + "img/graph-pink.1e1ef8a9.webp";